export default __webpack_public_path__ + "static/media/zebra_6_lightsalmonpink_diamond_wink_missing_teeth_cape.9f7e2b33.png";